<template>
  <div class="container">
      <!-- 用户信息 -->
    <div class="person-user-info" v-for=" (ietm,index) in userInfoList" :key="index">
      <div class="person-user-info-list nth">
        <span class="two-text">网吧：</span>
        <span>{{ietm.siteName}}</span>
      </div>
      <div class="person-user-info-list">
        <span class="two-text">区域：</span>
        <span>{{ietm.area}}</span>
      </div>
      <div class="person-user-info-list">
        <span class="three-text">所属单位:</span>
        <span>{{ietm.policeName}}</span>
      </div>
      <div class="person-user-info-list">
        <span class="three-text">姓名：</span>
        <span>{{ietm.principalName}}</span>
      </div>
       <div class="person-user-info-list">
        <span class="three-text">联系方式:</span>
        <span>{{ietm.principalTel}}</span>
      </div>
      <!-- <div class="person-user-info-list">
        <span class="more-title clearfix">问题描述：</span>
        <span class="more-text">电脑设备有问题请及时处理相关问题</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { userInfo } from "@/api/user"
import { rmdirSync } from 'fs'
export default {
   data() {
     return {
       userInfoList:[],
       siteName:'',
       area:'',
       policeName:'',
       principalName:'',
       principalTel:'',
     }
   },
   mounted() {
      this.requestUserInfo()
   },
   methods:{
    //  获取用户信息
     requestUserInfo() {
        let internetBarId = sessionStorage.getItem('internetBarId')
        userInfo({internetBarId:internetBarId}).then(res=>{
           console.log(res)
           this.userInfoList = res.data
          //  this.siteName = res.data.siteName
          //  this.area = res.data.area
          //  this.policeName = res.data.policeName
          //  this.principalName = res.data.principalName
          //  this.principalTel = res.data.principalTel
        }) 
     }
   }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
//   用户信息
  .person-user-info {
    width: 350px;
    height: 193px;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 10px;
    text-align: left;
    padding: 13px 19px;
    box-sizing: border-box;
    font-size: 14px;
    .person-user-info-list {
      margin-top: 23px;
      span {
        &:last-child {
          margin-left: 15px;
        }
      }
      .two-text {
        margin-left: 15px;
      }
      .three-text {
        margin-left: 13px;
      }
      .more-title {
        float: left;
      }
    }
    .nth {
      margin-top: 0;
    }
  }
}
</style>
